// The originCity draft value for an explicit "Current location" pick. It is
// client-side state only: queries and the URL carry no city instead, and the
// server measures from the shared visitor origin.
export const CURRENT_LOCATION = 'current'

export const appliedOriginCity = (originCity?: string | null): string | null =>
  originCity === CURRENT_LOCATION ? null : originCity || null
